/* Freshine support widget adapter: the sole theme integration point for support providers. */
(function () {
  'use strict';

  if (window.FreshineChat && window.FreshineChat.__themeAdapterInitialized) return;

  var MAX_ATTEMPTS = 20;
  var RETRY_DELAY = 250;
  var retryTimer = null;
  var attempts = 0;

  function openChatty() {
    var chattyTrigger = document.getElementById('Avada-FAQ_WidgetTrigger');
    var chattyButton = chattyTrigger && chattyTrigger.closest('.Avada-Faqs_Button');
    if (!chattyTrigger) return false;

    if (chattyButton && chattyButton.classList.contains('opened')) return true;

    if (typeof window.avadaFaqTrigger === 'function') {
      window.avadaFaqTrigger();
      return true;
    }

    chattyTrigger.click();
    return true;
  }

  function openLiveChatEmbed() {
    var container = document.getElementById('chat-widget-container');
    if (!container || !document.body) return false;

    var actionTrigger = document.createElement('button');
    actionTrigger.type = 'button';
    actionTrigger.hidden = true;
    actionTrigger.setAttribute('data-livechat-action', 'maximize');
    document.body.appendChild(actionTrigger);
    actionTrigger.click();
    actionTrigger.remove();

    var widget = document.getElementById('chat-widget');
    return Boolean(widget && window.getComputedStyle(widget).display !== 'none');
  }

  function openSupportWidget() {
    try {
      if (openChatty()) return true;

      if (window.LiveChatWidget && typeof window.LiveChatWidget.call === 'function') {
        window.LiveChatWidget.call('maximize');
        return true;
      }

      if (window.LC_API && typeof window.LC_API.open_chat_window === 'function') {
        window.LC_API.open_chat_window();
        return true;
      }

      if (openLiveChatEmbed()) return true;
    } catch (error) {
      // A provider can expose its API before it is ready; retry below handles that case.
    }

    return false;
  }

  function retryOpen() {
    retryTimer = null;

    if (openSupportWidget()) {
      attempts = 0;
      return;
    }

    attempts += 1;
    if (attempts < MAX_ATTEMPTS) {
      retryTimer = window.setTimeout(retryOpen, RETRY_DELAY);
    } else {
      attempts = 0;
    }
  }

  function open() {
    if (openSupportWidget()) {
      attempts = 0;
      return true;
    }

    if (!retryTimer) {
      attempts = 1;
      retryTimer = window.setTimeout(retryOpen, RETRY_DELAY);
    }

    return false;
  }

  window.FreshineChat = window.FreshineChat || {};
  window.FreshineChat.open = open;
  window.FreshineChat.__themeAdapterInitialized = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = target && target.closest ? target.closest('[data-open-chat="true"]') : null;
    if (!trigger) return;

    event.preventDefault();
    open();
  }, true);
})();
